import React from 'react';
import { Tooltip as AntToolTip } from 'antd';
import { BoldLabel } from '../../components';
import {
  Flag,
  BlueLabel,
  Credit,
  Debit,
  FlexWrapper,
  RiskLevelBadge,
  BeneficiaryMoreDetailsLink
} from './styled';
import { floor, truncate } from 'lodash';
import { HIGH_RISK_VALUE } from './constants';
import Tooltip from '../../components/Tooltip';
import {
  convertISOToDateFormat,
  convertISOToDateTimeFormat
} from '../../../../util/timezone';

const display = (str) => (str ? str : '-');

export default {
  defaultProperties: {
    ellipsis: true,
    render: (value) => (
      <div>
        <Tooltip content={value}>{truncate(value, { length: 15 })}</Tooltip>
      </div>
    )
  },
  customProperties: {
    transactionDate: {
      render: (_, record) => (
        <>{convertISOToDateTimeFormat(record.transactionDate)}</>
      )
    },
    isCredit: {
      render: (_, record) => {
        return (
          <FlexWrapper>
            {record.isCredit == undefined || record.isCredit == null ? (
              <>-</>
            ) : record.isCredit ? (
              <>
                <Credit /> CR
              </>
            ) : (
              <>
                <Debit /> DR
              </>
            )}
          </FlexWrapper>
        );
      }
    },
    amount: {
      render: (_, record) => (
        <AntToolTip title={record.amount} placement="topLeft">
          <BoldLabel>{floor(record.amount, 2)}</BoldLabel>
        </AntToolTip>
      )
    },
    transactionCurrencyAmount: {
      render: (_, record) => (
        <AntToolTip
          title={record.transactionCurrencyAmount}
          placement="topLeft">
          <BoldLabel>{floor(record.transactionCurrencyAmount, 2)}</BoldLabel>
        </AntToolTip>
      )
    },
    localCurrencyEquivalent: {
      render: (_, record) => (
        <AntToolTip title={record.localCurrencyEquivalent} placement="topLeft">
          <BoldLabel>{floor(record.localCurrencyEquivalent, 2)}</BoldLabel>
        </AntToolTip>
      )
    },
    countryOfTransaction: {
      render: (value, record) => (
        <Flag
          country={record.countryOfTransaction}
          showCountryName
          defaultValue={record.countryOfTransaction}
        />
      )
    },
    originatorBankCountryCode: {
      render: (value, record) => (
        <Flag
          country={record.originatorBankCountryCode}
          showCountryName
          defaultValue={record.originatorBankCountryCode}
        />
      )
    },
    beneficiaryBankCountryCode: {
      render: (value, record) => (
        <Flag
          country={record.beneficiaryBankCountryCode}
          showCountryName
          defaultValue={record.beneficiaryBankCountryCode}
        />
      )
    },
    transactionTypeCode: {
      render: (_, record) => <BlueLabel>{record.transactionTypeCode}</BlueLabel>
    },
    sourceOfTxnFunds: {
      render: (value, record) => (
        <FlexWrapper>
          <div>{record.sourceOfTxnFunds}</div>
          {record.sourceOfFundsRiskLevel == HIGH_RISK_VALUE && (
            <RiskLevelBadge>High Risk</RiskLevelBadge>
          )}
        </FlexWrapper>
      )
    },
    destinationOfFunds: {
      render: (value, record) => (
        <FlexWrapper>
          <div>{record.destinationOfFunds}</div>
          {record.destinationOfFundsRiskLevel == HIGH_RISK_VALUE && (
            <RiskLevelBadge>High Risk</RiskLevelBadge>
          )}
        </FlexWrapper>
      )
    },
    originatorBeneficiaryName: {
      ellipsis: true,
      render: (value, record) => (
        <div>
          <Tooltip
            content={`${record.originatorBankName || ''} - ${
              record.beneficialBankName || ''
            }`}>
            {truncate(
              `${record.originatorBankName || ''} - ${
                record.beneficialBankName || ''
              }`,
              { length: 15 }
            )}
          </Tooltip>
        </div>
      )
    },
    beneficiarySummary: {
      render: (value, record) => (
        <FlexWrapper>
          <div>
            {`${display(record.beneficiary)}, ${display(
              record.beneficiaryCustomerType
            )}, ${display(record.beneficiaryBankCountryCode)}`}
          </div>
          <Tooltip
            content={
              <>
                <div>
                  {`C2C linkage present: `}
                  <strong>{`${
                    record.beneficiaryC2cLinkagePresent ? 'Yes' : 'No'
                  }`}</strong>
                </div>
                <div>
                  {`Adverse news on beneficiary: `}
                  <strong>{`${
                    record.beneficiaryAdverseNews ? 'Yes' : 'No'
                  }`}</strong>
                </div>
              </>
            }>
            <BeneficiaryMoreDetailsLink>
              More Details
            </BeneficiaryMoreDetailsLink>
          </Tooltip>
        </FlexWrapper>
      )
    },
    bankBranchCode: {
      ellipsis: true,
      render: (_, record) => (
        <div>
          <Tooltip content={`${record.bankBranchCode || '-'}`}>
            {truncate(`${record.bankBranchCode || '-'}`)}
          </Tooltip>
        </div>
      )
    },
    transactionTypeDescription: {
      ellipsis: true,
      render: (_, record) => (
        <div>
          <Tooltip content={`${record.transactionTypeDescription || '-'}`}>
            {truncate(`${record.transactionTypeDescription || '-'}`)}
          </Tooltip>
        </div>
      )
    }
  }
};
